var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "131px",
    height: "145px",
    viewBox: "0 0 131 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.289245605
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-Detail",
    transform: "translate(-654.000000, -5589.000000)",
    fill: "#231710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVV",
    style: {
      mixBlendMode: "darken"
    },
    transform: "translate(80.000000, 5589.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(574.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "73 145 14.6947966 0 0 0 58.3052034 145"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "72.6937421 145 131 0 116.306258 0 58 145"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.003aa1ec49cb93c56035d2913cc246be.svg";
export { ForwardRef as ReactComponent };